<div class="revenue-dashboard-header">
  <div class="header-left">
    <div class="title-section">
      <div class="title-row">
        <h2 class="revenue-title">Revenue Dashboard</h2>
        <div class="migration-tag">
          <span class="tag-text">Way.com Migration: +18.2 %</span>
        </div>
      </div>
      <p class="revenue-description">Analyze shop revenue trends across services.</p>
    </div>
  </div>
  <div class="header-right">
    <div class="dropdown-container">
      <button
        class="today-dropdown"
        (click)="toggleLocationDropdown.emit(); $event.stopPropagation()"
      >
        <span>{{ selectedLocationLabel || 'All Locations' }}</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [class.rotated]="isLocationDropdownOpen"
        >
          <path
            d="M5.28 7.38L10 12.1L14.72 7.38"
            stroke="#15172E"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <div class="dropdown-menu" *ngIf="isLocationDropdownOpen" (click)="$event.stopPropagation()">
        <div class="dropdown-header">
          <span class="dropdown-title">Location</span>
        </div>
        <div class="dropdown-options">
          <div
            class="radio-option"
            *ngFor="let option of locationOptions; trackBy: trackByValue"
            (click)="selectLocation.emit(option.value)"
          >
            <div class="radio-button" [class.selected]="selectedLocation === option.value">
              <div class="radio-inner" *ngIf="selectedLocation === option.value"></div>
            </div>
            <span class="radio-label" [class.selected]="selectedLocation === option.value">{{
              option.label
            }}</span>
          </div>
          <div class="radio-option" *ngIf="!locationOptions?.length">
            <div class="radio-button selected">
              <div class="radio-inner"></div>
            </div>
            <span class="radio-label selected">No Location</span>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-container period-dropdown-wrapper" style="margin-right: 10px">
      <button class="today-dropdown" (click)="toggleDropdown.emit(); $event.stopPropagation()">
        <span>{{ selectedPeriodLabel || selectedPeriod }}</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [class.rotated]="isDropdownOpen"
        >
          <path
            d="M5.28 7.38L10 12.1L14.72 7.38"
            stroke="#15172E"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <app-date-range-picker
        [isOpen]="isDropdownOpen"
        [selectedPeriod]="selectedPeriod"
        [customDateRange]="customDateRange"
        [periodOptions]="periodOptions"
        (close)="closePeriodDropdown.emit()"
        (apply)="dateRangeApply.emit($event)"
      >
      </app-date-range-picker>
    </div>
  </div>
</div>

<div class="dashboard-stats-container">
  <div class="dashboard-stats-grid">
    <app-customer-stats-card
      *ngFor="let stat of dashboardStats; trackBy: trackByStatTitle"
      [data]="stat"
    >
    </app-customer-stats-card>
  </div>
</div>

<!-- Figma Empty State - Show when page loads and all data is empty -->
<div
  *ngIf="revenueStatsData === undefined || revenueStatsData?.is_revenue_generated === false"
  class="empty-state-container"
  style="margin-top: 24px"
>
  <div class="empty-state-content">
    <div class="empty-state-illustration">
      <img src="assets/images/empty-state-illustration.svg" alt="No data illustration" />
    </div>
    <div class="empty-state-text">
      <h3 class="empty-state-title">Nothing to show!</h3>
      <p class="empty-state-description">There is no car wash data to display.</p>
    </div>
  </div>
</div>

<!-- Normal Dashboard Content - Show when there's data or filters applied -->
<div *ngIf="revenueStatsData?.is_revenue_generated === true" class="dashboard-content">
  <div class="dashboard-row">
    <div class="dashboard-row-left">
      <div class="top-selling-card">
        <div class="card-header">
          <div class="header-content">
            <h3 class="card-title">Top Selling Service</h3>
            <div
              class="info-icon"
              [matTooltip]="'The service that sold most number of units in the selected period'"
              tabindex="0"
              matTooltipPosition="above"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
                  fill="#15172E"
                />
                <path
                  d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
                  fill="#15172E"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="card-content" *ngIf="topSellingService as tss">
          <div class="service-info">
            <div class="service-details">
              <h4 class="service-name">{{ tss.name }}</h4>
              <span class="units-sold">{{ tss.unitsSold }}</span>
            </div>
          </div>
          <div class="revenue-info">
            <span class="revenue-text">Revenue: ${{ tss.revenue.toLocaleString() }}</span>
            <span class="units-label">Units sold</span>
          </div>
        </div>
      </div>

      <div class="donut-chart-card">
        <div class="card-header">
          <div class="header-content">
            <h3 class="card-title">Revenue by Service Type</h3>
            <div
              class="info-icon"
              [matTooltip]="'Total number of sales for each type of service in the selected period.'"
              tabindex="0"
              matTooltipPosition="above"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
                  fill="#15172E"
                />
                <path
                  d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
                  fill="#15172E"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="chart-container">
          <!-- Show chart and legend only when there is meaningful data -->
          <div *ngIf="hasRevenueByServiceData()" style="width: 100%">
            <div class="donut-chart-wrapper">
              <canvas
                baseChart
                type="doughnut"
                [data]="revenueByServiceData"
                [options]="revenueByServiceOptions"
                class="donut-chart"
              >
              </canvas>
            </div>
            <div class="chart-legends" *ngIf="legendItems.length">
              <div class="legend-group" *ngFor="let group of legendGroups; trackBy: trackByIndex">
                <div class="legend-item" *ngFor="let item of group; trackBy: trackByLabel">
                  <div class="legend-dot" [ngStyle]="{ 'background-color': item.color }"></div>
                  <span class="legend-label" [title]="item.label">{{ item.label }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Show empty state when no data or all data is zero (only when filters applied) -->
          <ng-container
            *ngTemplateOutlet="
              tabNoDataMessage;
              context: { show: isRevenueByServiceDataEmpty() && shouldShowIndividualEmptyStates() }
            "
          ></ng-container>
        </div>
      </div>
    </div>
    <div class="line-chart-card">
      <div class="card-header">
        <div class="header-content">
          <h3 class="card-title">Revenue Trend by Day</h3>
          <div
            class="info-icon"
            [matTooltip]="'Daily revenue growth tracked every hour.'"
            tabindex="0"
            matTooltipPosition="above"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
                fill="#15172E"
              />
              <path
                d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
                fill="#15172E"
              />
            </svg>
          </div>
        </div>
      </div>
      <!-- Show chart only when there is meaningful data -->
      <div class="line-chart-wrapper" *ngIf="hasRevenueTrendData()">
        <canvas
          baseChart
          type="line"
          [data]="revenueTrendData"
          [options]="revenueTrendOptions"
          class="line-chart"
        >
        </canvas>
      </div>

      <!-- Show empty state when no data or all data is zero (only when filters applied) -->
      <ng-container
        *ngTemplateOutlet="
          tabNoDataMessage;
          context: { show: isRevenueTrendDataEmpty() && shouldShowIndividualEmptyStates() }
        "
      ></ng-container>
    </div>
  </div>
</div>

<div class="revenue-fullwidth-section" *ngIf="revenueStatsData?.is_revenue_generated === true">
  <div class="revenue-fullwidth-card">
    <div class="card-header">
      <div class="header-content">
        <h3 class="card-title">Average Revenue per Wash Trend</h3>
        <div
          class="info-icon"
          [matTooltip]="'Average revenue change per car wash over time.'"
          tabindex="0"
          matTooltipPosition="above"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
              fill="#15172E"
            />
            <path
              d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
              fill="#15172E"
            />
          </svg>
        </div>
      </div>
    </div>
    <!-- Show chart only when there is meaningful data -->
    <div class="revenue-fullwidth-chart-wrapper" *ngIf="hasAvgRevenuePerTeamData()">
      <canvas
        baseChart
        type="line"
        [data]="avgRevenuePerTeamData"
        [options]="avgRevenuePerTeamOptions"
        class="revenue-fullwidth-chart"
      >
      </canvas>
    </div>

    <!-- Show empty state when no data or all data is zero (only when filters applied) -->
    <ng-container
      *ngTemplateOutlet="
        tabNoDataMessage;
        context: { show: isAvgRevenuePerTeamDataEmpty() && shouldShowIndividualEmptyStates() }
      "
    ></ng-container>
  </div>
</div>

<!-- No Data Message Template (reused for all 3 empty-state chart sections) -->
<ng-template #tabNoDataMessage let-show="show">
  <div *ngIf="show">
    <div class="no-data-message">
      <p class="p5">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00032 5.9998V8.66647M8.00032 10.6665H8.00698M6.90898 2.3938L1.50498 11.4165C1.39358 11.6094 1.33463 11.8281 1.33399 12.0509C1.33335 12.2737 1.39105 12.4927 1.50135 12.6863C1.61164 12.8798 1.77069 13.0412 1.96268 13.1542C2.15466 13.2672 2.37289 13.328 2.59565 13.3305H13.405C13.6276 13.3279 13.8458 13.2671 14.0377 13.1541C14.2295 13.0411 14.3885 12.8799 14.4988 12.6865C14.6091 12.493 14.6668 12.2741 14.6663 12.0514C14.6657 11.8287 14.6069 11.61 14.4956 11.4171L9.09165 2.39313C8.97795 2.20547 8.81778 2.0503 8.62662 1.9426C8.43545 1.8349 8.21973 1.77832 8.00032 1.77832C7.7809 1.77832 7.56519 1.8349 7.37402 1.9426C7.18285 2.0503 7.02268 2.20547 6.90898 2.39313V2.3938Z"
            stroke="#717683"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        No data available for the selected period.
      </p>
    </div>
  </div>
</ng-template>
